
















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptCargeJournal extends Vue {

  // 出荷予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public onExcelExport :boolean = false;
  public bookDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public bookDateToFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.ChargeJournalReportTemplateQuery = new Common.ChargeJournalReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.bookDateFrom = new Date().getCalendarDate();
    this.bookDateFrom.setDate(1);
    this.bookDateTo = new Date().getCalendarDate();
    this.bookDateTo.setMonth(this.bookDateFrom.getMonth() + 1);
    this.bookDateTo.setDate(0);

    (this.$refs.ChargeJournalDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.ChargeJournalReportQuery = new Common.ChargeJournalReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.bookDateFrom = this.bookDateFrom;
    query.bookDateTo = this.bookDateTo;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
